// eslint-disable-next-line import/prefer-default-export
export const tableFields = [
  { key: 'local_id', label: 'id', _style: { width: '10%' } },
  { key: 'external_id', label: 'External Id', _style: { width: '10%' } },
  { key: 'user', label: 'Assigned To', _style: { width: '23%' } },
  { key: 'canvasser', _style: { width: '22%' } },
  {
    key: 'total_prospects', label: 'Prospects', _style: { width: '10%' }, sorter: false,
  },
  { key: 'labels', _style: { width: '25%' }, sorter: false },
];
